import { apiClient } from './client';

export const bookmarksApi = apiClient.injectEndpoints({
    endpoints: (builder) => ({
        getBookmarks: builder.query({
            query: (bookId: string) => ({
                url: '/api/bookmarks',
                method: 'GET',
                params: { book_id: bookId },
            }),
        }),

        addBookmark: builder.mutation({
            query: (bookmark) => ({
                url: '/api/bookmarks',
                method: 'POST',
                body: bookmark,
            }),
        }),

        deleteBookmark: builder.mutation({
            query: ({
                id,
                bookId,
            }: {
                id: number;
                bookId: string | number;
            }) => ({
                url: '/api/bookmarks',
                method: 'DELETE',
                body: { id: id, book_id: bookId },
            }),
        }),
    }),
});

export const {
    useGetBookmarksQuery,
    useAddBookmarkMutation,
    useDeleteBookmarkMutation,
} = bookmarksApi;
